module.exports = __webpack_public_path__ + "static/pergola-3-fe823e79b82be72827fb707948a13335.jpg";